/** Moves a single-use token out of the URL and into a short-lived cookie. */
import { createIsomorphicFn } from "@tanstack/react-start";
import { setCookie } from "@tanstack/react-start/server";
import type { SerializeOptions } from "cookie";

import { setCookie as setClientCookie } from "@/utils/cookies";

export { TOKEN_HANDOFF_MAX_AGE_SECONDS } from "@/config/constants";

type TokenCookie = {
  name: string;
  value: string;
  options: SerializeOptions;
};

/**
 * Writes the cookie on whichever side is running.
 *
 * The server branch looks dead — `src/server.ts` intercepts both handoff paths
 * before the router sees them — but its regexes are case-sensitive where the
 * router matches case-insensitively, so `/ACTIVATION/<token>/CONFIRM` reaches
 * `beforeLoad` on the server. Deleting it would drop the cookie on mixed-case
 * links.
 */
export const writeTokenCookie = createIsomorphicFn()
  .server((cookie: TokenCookie) => {
    setCookie(cookie.name, cookie.value, cookie.options);
  })
  .client((cookie: TokenCookie) => {
    setClientCookie(cookie.name, cookie.value, cookie.options);
  });
